import { combineReducers } from 'redux';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
// slices
import mailReducer from './slices/mail';
import chatReducer from './slices/chat';
import productReducer from './slices/product';
import calendarReducer from './slices/calendar';
import kanbanReducer from './slices/kanban';
import assetReducer from './slices/asset';
import siteReducer from './slices/site';
import swReducer from './slices/sw'
import notiReducer from './slices/notification'
import socialReducer from './slices/social';
import questReducer from './slices/quest';

// ----------------------------------------------------------------------

const rootPersistConfig = {
  key: 'root',
  storage,
  keyPrefix: 'redux-',
  whitelist: [],
};

const productPersistConfig = {
  key: 'product',
  storage,
  keyPrefix: 'redux-',
  whitelist: ['sortBy', 'checkout'],
};

const rootReducer = combineReducers({
  mail: mailReducer,
  chat: chatReducer,
  calendar: calendarReducer,
  kanban: kanbanReducer,
  product: persistReducer(productPersistConfig, productReducer),
  asset: assetReducer,
  site: siteReducer,
  sw: swReducer,
  noti: notiReducer,
  social: socialReducer,
  quest: questReducer,
});

export { rootPersistConfig, rootReducer };
